import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpEventType
} from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { tap, filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class DuplicateCallInterceptor implements HttpInterceptor {

  /**
   * Almacena las peticiones activas
   */
  private readonly activeCalls: Map<string, Subject<any>> = new Map();

  /**
   * Encargado de verificar si existe una petición al mismo recurso en espera
   * @param request 
   * @param next 
   * @returns 
   */
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    if(request.url.includes('.json')){
      if (this.activeCalls.has(request.url)) {
        const subject = this.activeCalls.get(request.url);
        if (subject) {
          return subject.asObservable();
        }
      }
      this.activeCalls.set(request.url, new Subject<any>());
      return next.handle(request)
        .pipe(
          filter(res => res.type === HttpEventType.Response),
          tap(res => {
            const subject = this.activeCalls.get(request.url);
            if (subject) {
              subject.next(res);
              subject.complete();
              this.activeCalls.delete(request.url);
            }
  
          })
        )
    }else{
      return next.handle(request);
    }
    
  }
}
